// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vzT4","inner":"Footer_inner__1WXCC","nextIcon":"Footer_nextIcon__3S1EJ","innerLeft":"Footer_innerLeft__3dtIo"};